import { render, staticRenderFns } from "./AdminStaff.vue?vue&type=template&id=c3f12eaa&scoped=true"
import script from "./AdminStaff.vue?vue&type=script&lang=js"
export * from "./AdminStaff.vue?vue&type=script&lang=js"
import style0 from "./AdminStaff.vue?vue&type=style&index=0&id=c3f12eaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f12eaa",
  null
  
)

export default component.exports